import React from 'react';
import { ConnectedSwapButton } from './SwapButton';
import { SwapButtonDesktopEl } from './SwapButtonDesktop.style';

export const SwapButtonDesktop = () => {
    const getRotateStyle = (rotate) => rotate ? 'rotate(180deg)' : 'rotate(0deg)';
    const buttonClass = 'odf-btn-circle-m';

    return (
        <SwapButtonDesktopEl
            className='odf-space-outer-right-xl odf-z-index-4 odf-position-absolute'
        >
            <ConnectedSwapButton
                buttonClass={buttonClass}
                getRotateStyle={getRotateStyle}
            />
        </SwapButtonDesktopEl>

    );
};
